<template>
  <div v-if="errorStatus.error === 'access_denied'">
    <not-authorized message="cgu" />
  </div>
  <router-view v-else />
</template>

<script>
import { parseDate } from '@/utils/dateHelpers';
import { hasMismatchPeriods, isEmptyTime } from '@/utils/helpers';
import NotAuthorized from './components/NotAuthorized.vue';
import store from './store';

const comparingOneMapPath = '/MapF6Diff';
const comparingTwoMapPath =  '/MapF6Double';

export default {
  components: { NotAuthorized },
  data () {
    return {
      ...store,
    };
  },
  watch: {
    $route: {
      handler (to, from) {
        document.title = to.meta.title || 'Outdoor Vision';

        // when going to F6 from all views (exception F6 double)
        // or going to F6double from all views (exception F6 double)
        const resetPeriod2 = (to.path === comparingOneMapPath && from.path !== comparingTwoMapPath)
          || (to.path === comparingTwoMapPath && from.path !== comparingOneMapPath);

        // if the periode 1 (time) type is different from the previous period 2 (time2)
        const periodsMismatch = hasMismatchPeriods(store.params.time, store.params.time2);
        // or if time2 is empty
        const isPeriod2Empty = isEmptyTime(store.params.time2);

        if (resetPeriod2 && (periodsMismatch || isPeriod2Empty)) {
          // set time2 as the same as time
          store.updateTime2(store.params.time);
        }

        // when going to/from F6Diff, we handle yearMin / yearMax a bit differently
        // for F6MapDouble, yearMin and yearMax are used for the first map only
        if (to.path === '/MapF6Diff') {
          // take into account both date range to determine yearMin and yearMax
          const minDate = store.params.windowOpen <= store.params.windowOpen2
            ? store.params.windowOpen
            : store.params.windowOpen2;
          const maxDate = store.params.windowClose >= store.params.windowClose2
            ? store.params.windowClose
            : store.params.windowClose2;

          const minYear = minDate ? parseDate(minDate).getFullYear() : this.$minDate.getFullYear();
          const maxYear = maxDate ? parseDate(maxDate).getFullYear() : this.$maxDate.getFullYear();
          store.updateYearMin(minYear);
          store.updateYearMax(maxYear);
        }

        if (to.path !== '/MapF6Diff') {
          // take into account the only date range to determine yearMin and yearMax
          const minYear = store.params.windowOpen
            ? parseDate(store.params.windowOpen).getFullYear()
            : this.$minDate.getFullYear();
          const maxYear = store.params.windowClose
            ? parseDate(store.params.windowClose).getFullYear()
            : this.$maxDate.getFullYear();
          store.updateYearMin(minYear);
          store.updateYearMax(maxYear);
        }
      },
    },
  },
};
</script>
